import React, { useMemo } from 'react';
import { DateUtils } from '@vectord/utils';
import { useParams } from 'react-router-dom';
import orderBy from 'lodash/orderBy';

import { useGetSbatGroupListQuery } from 'features/classCreation';
import AcademyModuleFilter from '../AcademyModuleFilter';
import AcademyTopicFilter from '../AcademyTopicFilter';
import DateRangeFilter from '../DateRangeFilter';
import FilterDrawerHeader from '../FilterDrawerHeader';
import InstructorsFilter from '../InstructorsFilter';
import SbatGroupFilterChips from '../SbatGroupFilterChips';
import SuperBatchesFilter from '../SuperBatchesFilter';

function FilterDrawerContent() {
  const { superBatchId } = useParams();
  const { data } = useGetSbatGroupListQuery(Number(superBatchId));

  const upcomingSbatGroups = useMemo(() => {
    const sbatGroups = data?.data || [];

    return orderBy(
      sbatGroups.filter(
        (sbatGroup) =>
          new Date(sbatGroup.date_of_topic) >= Date.now() - DateUtils.ONE_HOUR
      ),
      (o) => new Date(o.date_of_topic),
      'asc'
    );
  }, [data?.data]);

  return (
    <>
      <FilterDrawerHeader />
      <div className="m-t-m m-b-xs h3 bold dark">All Filters</div>
      <SbatGroupFilterChips />
      <InstructorsFilter sbatGroups={upcomingSbatGroups} />
      <AcademyModuleFilter sbatGroups={upcomingSbatGroups} />
      <AcademyTopicFilter sbatGroups={upcomingSbatGroups} />
      <SuperBatchesFilter sbatGroups={upcomingSbatGroups} />
      <DateRangeFilter />
    </>
  );
}

export default FilterDrawerContent;
